import { useState, useEffect, useContext } from "react";
import { Row, Col, Form, Container } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import "../components/LandingPage.css";
import VN from "../components/VN";
import { UserDataContext } from "../components/UserDataContext";
import "../components/button.css";
import Alerts from "../components/Alerts";
import {
  TextField,
  FormControl,
  Typography,
  Button,
  Box,
  Paper,
  InputAdornment,
} from "@mui/material";
import img4 from "../images/Oldpeople.jpg";
import img2 from "../images/logo2.png";
import soon from "../images/soon1.png";
import { marginTop } from "../App";
import { marginBottom } from "../App";
import { apiRequest } from "../components/Config";
import { fetchUserData } from "../components/auth";
import AccountCircle from "@mui/icons-material/AccountCircle";
import LockIcon from "@mui/icons-material/Lock";
import LoginIcon from "@mui/icons-material/Login";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import SearchIcon from "@mui/icons-material/Search";
import VerifiedUserIcon from "@mui/icons-material/VerifiedUser";

import "@fontsource/lato/300.css";
import "@fontsource/lato/400.css";
import "@fontsource/lato/700.css";

const Login = () => {
  const [user, setUser] = useState("");
  const [password, setPassword] = useState("");
  const [apiResponse, setApiResponse] = useState({});
  const navigate = useNavigate();
  const { userData, setUserData } = useContext(UserDataContext);
  const [show, setShow] = useState(false);
  const [showApiResponse, setShowApiResponse] = useState(false);
  const [fadeOut, setFadeOut] = useState(false);
  const ClearApiResponse = () => {
    setShowApiResponse(false);
  };
  useEffect(() => {
    // Blokada dla środowiska deweloperskiego (localhost)
    if (process.env.NODE_ENV === "development") {
      return;
    }

    const sendIpToApi = async () => {
      try {
        const ipResponse = await fetch("https://api.ipify.org?format=json");
        if (!ipResponse.ok) throw new Error("Nie udało się pobrać IP");
        const ipData = await ipResponse.json();
        const userIp = ipData.ip;
        const response = await apiRequest("send-email-entry", "POST", {
          ip: userIp,
        });
        console.log("OK", response);
      } catch (error) {
        console.error("Błąd podczas pobierania lub wysyłania IP:", error);
      }
    };

    sendIpToApi();
  }, []);
  const handleSubmit = async (event) => {
    event.preventDefault();
    try {
      const response = await apiRequest("login", "POST", {
        user: user,
        password: password,
      });
      setUserData(response);
      const group = response.group;
      const type = response.type;

      if (response.error_msg === 200) {
        if (group === 1) navigate("/admin");
        if (group === 2) console.log("Weryfikacja");
        if (group === 3) navigate("/profile");
        if (type === 2) navigate("/seeker");
      }

      if (response.error_msg === 403) {
        setApiResponse({
          title: "Błąd",
          severity: "error",
          info: "Brak uprawnień lub niewłaściwe hasło!",
        });
        setShowApiResponse(true);
      }
      if (response.error_msg === 501) {
        setApiResponse({
          title: "Błąd",
          severity: "error",
          info: "Konto nieaktywne, zablokowane lub nie istnieje!",
        });
        setShowApiResponse(true);
      }
      if (response.error_msg === 502) {
        setApiResponse({
          title: "Ostrzeżenie",
          severity: "warning",
          info: "Nie podano nazwy użytkownika.",
        });
        setShowApiResponse(true);
      }
      if (response.error_msg === 503) {
        setApiResponse({
          title: "Ostrzeżenie",
          severity: "warning",
          info: "Nie podano hasła.",
        });
        setShowApiResponse(true);
      }
    } catch (error) {
      setApiResponse({
        title: "Błąd",
        severity: "error",
        info: "Błąd podczas wysyłania danych.",
      });
      setShowApiResponse(true);
      navigate("/nopermission");
    }
  };

  useEffect(() => {
    const verifyUser = async () => {
      try {
        await fetchUserData();
      } catch (error) {
        console.error("Błąd podczas weryfikacji użytkownika:", error);
      }
    };
    verifyUser();
  }, [navigate, setUserData]);

  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      handleSubmit(event);
    }
  };

  const handleShow = () => {
    setShow(!show);
  };

  const handleFind = () => {
    console.log("Logged: ", userData?.userId);
    if (userData?.userId === undefined || userData?.userId === 0) {
      setApiResponse({
        title: "Błąd",
        severity: "error",
        info: "Musisz być zalogowany, by wyświetlać opiekunki",
      });

      setShowApiResponse(true);
      setFadeOut(false);

      setTimeout(() => {
        setFadeOut(true);
      }, 4000);

      setTimeout(() => {
        setShowApiResponse(false);
        setFadeOut(false);
      }, 5000);
    }
  };

  return (
    <div
      style={{
        fontFamily: "'Lato', sans-serif",
        backgroundColor: "#fafafa",
        minHeight: "100vh",
      }}
    >
      <VN />

      {showApiResponse && (
        <Row className="sticky-alerts-container">
          <Alerts data={apiResponse} />
        </Row>
      )}

      <Container style={{ paddingTop: "20px" }}>
        {/* NAGŁÓWEK I PANEL LOGOWANIA */}
        <Form onKeyDown={handleKeyDown}>
          <Row
            className="align-items-center justify-content-between"
            style={{ marginBottom: "50px" }}
          >
            <Col
              md={3}
              sm={12}
              className="text-center text-md-start mb-3 mb-md-0"
            >
              <img
                src={img2}
                alt="Logo"
                style={{ maxWidth: "180px", height: "auto" }}
              />
            </Col>

            <Col md={9} sm={12}>
              <Row className="align-items-center justify-content-md-end g-3">
                <Col xs={12} sm={4} md={4}>
                  <FormControl fullWidth>
                    <TextField
                      label="Identyfikator / Konto"
                      type="text"
                      variant="outlined"
                      size="small"
                      value={user || ""}
                      onChange={(e) => {
                        setUser(e.target.value);
                        ClearApiResponse();
                      }}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <AccountCircle
                              fontSize="small"
                              sx={{ color: "text.secondary" }}
                            />
                          </InputAdornment>
                        ),
                      }}
                    />
                  </FormControl>
                </Col>

                <Col xs={12} sm={4} md={4}>
                  <FormControl fullWidth>
                    <TextField
                      label="Hasło"
                      type="password"
                      variant="outlined"
                      size="small"
                      value={password || ""}
                      onChange={(e) => {
                        setPassword(e.target.value);
                        ClearApiResponse();
                      }}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <LockIcon
                              fontSize="small"
                              sx={{ color: "text.secondary" }}
                            />
                          </InputAdornment>
                        ),
                      }}
                    />
                  </FormControl>
                </Col>

                <Col xs={12} sm="auto">
                  <Button
                    variant="contained"
                    color="primary"
                    fullWidth
                    onClick={handleSubmit}
                    startIcon={<LoginIcon />}
                    sx={{
                      fontWeight: 600,
                      px: 3,
                      height: "40px",
                      borderRadius: "8px",
                      textTransform: "none",
                      backgroundColor: "#1a237e",
                      "&:hover": { backgroundColor: "#0d1b60" },
                    }}
                  >
                    Zaloguj się
                  </Button>
                </Col>
              </Row>
            </Col>
          </Row>
          <Row>
            <Col xs={12} sm="auto" className="ms-auto text-end">
              Jeśli nie pamiętasz hasła - kliknij tu:{" "}
              <a href="pass-reset">Reset hasła</a>
            </Col>
          </Row>
          {/* GŁÓWNY TYTUŁ HERO */}
          <Row style={{ marginTop, marginBottom: "30px" }}>
            <Col md={12}>
              <Typography
                variant="h3"
                component="h1"
                sx={{
                  fontWeight: 800,
                  color: "#1a237e",
                  letterSpacing: "-0.5px",
                  fontSize: { xs: "2.2rem", md: "3.2rem" },
                }}
              >
                Bezpieczna opieka dla Twoich najbliższych
              </Typography>
            </Col>
          </Row>
        </Form>

        {/* SEKCJA GŁÓWNA (TEKST + ZDJĘCIE) */}
        <Row className="align-items-start" style={{ marginBottom }}>
          <Col lg={7} md={12} className="mb-4 mb-lg-0">
            <Box sx={{ position: "relative", mb: 4 }}>
              <Typography
                variant="h6"
                component="p"
                sx={{
                  color: "#455a64",
                  fontWeight: 400,
                  lineHeight: 1.7,
                  fontSize: "1.2rem",
                  position: "relative",
                  zIndex: 2,
                }}
              >
                Wiemy, jak trudno powierzyć bliską osobę komuś obcemu. <br />
                Dlatego każda opiekunka w naszym serwisie przechodzi{" "}
                <strong>indywidualną, rzetelną weryfikację</strong>. <br />
                Sprawdzamy doświadczenie, dokumenty i referencje – abyś miał
                absolutną pewność, że Twoi bliscy są w najlepszych rękach.
              </Typography>

              {/* Tło znaku wodnego "Soon" */}
              <img
                src={soon}
                alt="Wkrótce"
                style={{
                  position: "absolute",
                  top: "-10%",
                  left: "5%",
                  width: "75%",
                  opacity: 0.12,
                  transform: "rotate(-10deg)",
                  pointerEvents: "none",
                  zIndex: 1,
                }}
              />
            </Box>

            {/* AKCJE I BUTTONY */}
            <Box sx={{ display: "flex", gap: 2, flexWrap: "wrap", mb: 4 }}>
              <Button
                variant="contained"
                color="success"
                size="large"
                onClick={handleFind}
                startIcon={<SearchIcon />}
                sx={{
                  fontWeight: 600,
                  textTransform: "none",
                  borderRadius: "10px",
                  px: 3,
                  py: 1.5,
                  boxShadow: "0 4px 14px rgba(46, 125, 50, 0.25)",
                }}
              >
                Znajdź zweryfikowaną opiekunkę
              </Button>

              <Button
                variant="outlined"
                color="primary"
                size="large"
                onClick={handleShow}
                startIcon={<VerifiedUserIcon />}
                sx={{
                  fontWeight: 600,
                  textTransform: "none",
                  borderRadius: "10px",
                  px: 3,
                  py: 1.5,
                }}
              >
                {show
                  ? "Ukryj proces weryfikacji"
                  : "Sprawdź jak weryfikujemy opiekunki"}
              </Button>
            </Box>
            {show && (
              <Paper
                elevation={0}
                sx={{
                  p: 3,
                  backgroundColor: "#e8f5e9",
                  borderRadius: "16px",
                  borderLeft: "5px solid #2e7d32",
                  boxShadow: "0px 4px 20px rgba(0,0,0,0.03)",
                }}
              >
                <Typography
                  variant="h6"
                  sx={{ fontWeight: 700, color: "#1b5e20", mb: 2 }}
                >
                  Rzetelna weryfikacja przed dołączeniem do serwisu
                </Typography>
                <Typography
                  variant="body2"
                  sx={{ color: "#2e7d32", mb: 3, fontWeight: 500 }}
                >
                  Każda kandydatka przechodzi restrykcyjny proces sprawdzania
                  przez wykwalifikowany personel.
                </Typography>

                <Row className="g-3">
                  {[
                    "Tożsamość i niekaralność użytkownika",
                    "Udokumentowane doświadczenie w opiece",
                    "Pozytywne referencje od poprzednich rodzin",
                    "Kwalifikacje, dyplomy oraz odbyte kursy medyczne",
                    "Indywidualna rozmowa kwalifikacyjno-weryfikacyjna",
                  ].map((text, i) => (
                    <Col
                      xs={12}
                      sm={6}
                      key={i}
                      className="d-flex align-items-center"
                    >
                      <CheckCircleIcon
                        sx={{ color: "#2e7d32", mr: 1.5, fontSize: 20 }}
                      />
                      <Typography
                        variant="body2"
                        sx={{ color: "#37474f", fontWeight: 600 }}
                      >
                        {text}
                      </Typography>
                    </Col>
                  ))}
                </Row>

                <Box
                  sx={{
                    mt: 3,
                    pt: 2,
                    borderTop: "1px style solid rgba(46,125,50,0.1)",
                  }}
                >
                  <Typography
                    variant="caption"
                    sx={{
                      color: "#1b5e20",
                      fontWeight: 700,
                      textTransform: "uppercase",
                      letterSpacing: "0.5px",
                    }}
                  >
                    Gwarancja pewności i bezpieczeństwa wyboru
                  </Typography>
                </Box>
              </Paper>
            )}
          </Col>
          <Col
            lg={5}
            md={12}
            className="d-flex justify-content-center justify-content-lg-end"
          >
            <Paper
              elevation={0}
              sx={{
                p: 2,
                backgroundColor: "#fff",
                border: "1px solid #e0e0e0",
                borderRadius: "16px",
                boxShadow: "0px 10px 30px rgba(0, 0, 0, 0.06)",
                maxWidth: "400px",
                width: "100%",
                transition: "transform 0.3s",
                "&:hover": { transform: "scale(1.02)" },
              }}
            >
              <img
                src={img4}
                alt="Moi Rodzice"
                style={{
                  width: "100%",
                  height: "auto",
                  borderRadius: "10px",
                  display: "block",
                }}
              />
            </Paper>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Login;
